function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".toggle_truncated_bb_svg__cls-1,.toggle_truncated_bb_svg__cls-4{fill:none}.toggle_truncated_bb_svg__cls-1{stroke:#fff;stroke-dasharray:1 1}.toggle_truncated_bb_svg__cls-2{fill:#fff}.toggle_truncated_bb_svg__cls-3{stroke:none}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "toggle_truncated_bb_svg__Group_22065",
  transform: "translate(5.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "toggle_truncated_bb_svg__Rectangle_7812",
  className: "toggle_truncated_bb_svg__cls-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h14v14H0z",
  className: "toggle_truncated_bb_svg__cls-3",
  transform: "translate(.999 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h13v13H.5z",
  className: "toggle_truncated_bb_svg__cls-4",
  transform: "translate(.999 1)"
})), /*#__PURE__*/React.createElement("circle", {
  id: "toggle_truncated_bb_svg__Ellipse_685",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "toggle_truncated_bb_svg__cls-2",
  transform: "translate(-.001)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "toggle_truncated_bb_svg__Ellipse_686",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "toggle_truncated_bb_svg__cls-2",
  transform: "translate(12.999 13)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "toggle_truncated_bb_svg__Ellipse_791",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "toggle_truncated_bb_svg__cls-2",
  transform: "translate(-.001 13)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "toggle_truncated_bb_svg__Ellipse_792",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "toggle_truncated_bb_svg__cls-2",
  transform: "translate(12.999)"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "toggle_truncated_bb_svg__Group_22064",
  transform: "translate(.001 4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "toggle_truncated_bb_svg__Rectangle_8010",
  className: "toggle_truncated_bb_svg__cls-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h14v14H0z",
  className: "toggle_truncated_bb_svg__cls-3",
  transform: "translate(.999 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h13v13H.5z",
  className: "toggle_truncated_bb_svg__cls-4",
  transform: "translate(.999 1)"
})), /*#__PURE__*/React.createElement("circle", {
  id: "toggle_truncated_bb_svg__Ellipse_796",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "toggle_truncated_bb_svg__cls-2",
  transform: "translate(-.001)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "toggle_truncated_bb_svg__Ellipse_794",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "toggle_truncated_bb_svg__cls-2",
  transform: "translate(12.999 13)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "toggle_truncated_bb_svg__Ellipse_795",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "toggle_truncated_bb_svg__cls-2",
  transform: "translate(-.001 13)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "toggle_truncated_bb_svg__Ellipse_793",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  className: "toggle_truncated_bb_svg__cls-2",
  transform: "translate(12.999)"
}));
function SvgToggleTruncatedBb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "toggle_truncated_bb_svg__Component_125_2",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20"
  }, props), _ref, _ref2, _ref3);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Component_125_2' width='21' height='20' viewBox='0 0 21 20'%3e %3cdefs%3e %3cstyle%3e .cls-1,.cls-4%7bfill:none%7d.cls-1%7bstroke:%23fff;stroke-dasharray:1 1%7d.cls-2%7bfill:%23fff%7d.cls-3%7bstroke:none%7d %3c/style%3e %3c/defs%3e %3cg id='Group_22065' transform='translate(5.001)'%3e %3cg id='Rectangle_7812' class='cls-1'%3e %3cpath d='M0 0H14V14H0z' class='cls-3' transform='translate(.999 1)'/%3e %3cpath d='M0.5 0.5H13.5V13.5H0.5z' class='cls-4' transform='translate(.999 1)'/%3e %3c/g%3e %3ccircle id='Ellipse_685' cx='1.5' cy='1.5' r='1.5' class='cls-2' transform='translate(-.001)'/%3e %3ccircle id='Ellipse_686' cx='1.5' cy='1.5' r='1.5' class='cls-2' transform='translate(12.999 13)'/%3e %3ccircle id='Ellipse_791' cx='1.5' cy='1.5' r='1.5' class='cls-2' transform='translate(-.001 13)'/%3e %3ccircle id='Ellipse_792' cx='1.5' cy='1.5' r='1.5' class='cls-2' transform='translate(12.999)'/%3e %3c/g%3e %3cg id='Group_22064' transform='translate(.001 4)'%3e %3cg id='Rectangle_8010' class='cls-1'%3e %3cpath d='M0 0H14V14H0z' class='cls-3' transform='translate(.999 1)'/%3e %3cpath d='M0.5 0.5H13.5V13.5H0.5z' class='cls-4' transform='translate(.999 1)'/%3e %3c/g%3e %3ccircle id='Ellipse_796' cx='1.5' cy='1.5' r='1.5' class='cls-2' transform='translate(-.001)'/%3e %3ccircle id='Ellipse_794' cx='1.5' cy='1.5' r='1.5' class='cls-2' transform='translate(12.999 13)'/%3e %3ccircle id='Ellipse_795' cx='1.5' cy='1.5' r='1.5' class='cls-2' transform='translate(-.001 13)'/%3e %3ccircle id='Ellipse_793' cx='1.5' cy='1.5' r='1.5' class='cls-2' transform='translate(12.999)'/%3e %3c/g%3e %3c/svg%3e";
export { SvgToggleTruncatedBb as ReactComponent };